import QuestionWangEditor from './src/main.js'

export default QuestionWangEditor



// WEBPACK FOOTER //
// ./src/views/question-editor/components/question-wang-editor/index.js